<template>
  <div :class="['flash-container', { hidden: isHidden }]">
    <p
      v-if="localSuccess"
      :class="['flash success', { hidden: isHidden }]"
    >
      {{ localSuccess }}
    </p>

    <p
      v-if="localError"
      :class="['flash error', { hidden: isHidden }]"
    >
      {{ localError }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'FlashMessages',

  props: {
    error: {
      type: String,
      default: null
    },

    success: {
      type: String,
      default: null
    },

    clearFlashMessages: {
      type: Function,
      required: true
    }
  },

  data () {
    return {
      isHidden: true,
      localSuccess: null,
      localError: null,
      timeoutId: null
    }
  },

  watch: {
    success (newVal) {
      this.localSuccess = newVal
      this.isHidden = false
      this.clearAfterDelay('success')
    },
    error (newVal) {
      this.localError = newVal
      this.isHidden = false
      this.clearAfterDelay('error')
    }
  },

  mounted () {
    if (this.success) {
      this.localSuccess = this.success
    }
    if (this.error) {
      this.localError = this.error
    }
  },

  methods: {
    clearAfterDelay (type) {
      const fadeAfter = 3000
      const fadeDuration = 500
      if (this.timeoutId) {
        clearTimeout(this.timeoutId)
      }

      this.timeoutId = setTimeout(() => {
        this.isHidden = true
        setTimeout(() => {
          this.clearFlashMessages()
        }, fadeAfter + fadeDuration)
      }, fadeAfter)
    }
  }
}
</script>
